export default {
  methods: {
    get(object, keyChain, def = "") {
      return keyChain.split(".").reduce(function(obj, field) {
        return typeof obj == "undefined" || obj === null ? def : obj[field];
      }, object);
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/objectMixin.js